@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;

.styledDropdownMenu {
  @include respond-to('mobile') {
    width: 250px;
    min-width: 250px;
  }
}

.prefixText {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}

.optionWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.label {
  @include typography-v2-body-sm;
}

.styledChip {
  padding: 6px 8px;
  gap: 4px;

  > div > svg {
    margin-left: 8px;
  }
}

.styledOptionWrapperDisabled {
  [data-item-description] {
    color: var(--text-disabled);
  }
}
